import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CardUploadListing, CardUploadAddEdit } from './Pages';

export const CardUploadRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={CardUploadAddEdit} />
    </Fragment>
)